"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useContentTracker;
var _react = require("react");
var _contexts = require("../contexts");
const THRESHOLD_TIME = 3000; // minimum ms between two updates to be counted

function useContentTracker(currentContent) {
  const {
    trackerEnabled
  } = (0, _react.useContext)(_contexts.Settings);
  const {
    addReadContent
  } = (0, _react.useContext)(_contexts.Storage);
  const previousContent = usePrevious(currentContent, trackerEnabled) || {};
  const prevTs = previousContent.ts || 0;
  (0, _react.useEffect)(() => {
    if (!trackerEnabled) return;
    if (currentContent.ts - prevTs >= THRESHOLD_TIME) {
      addReadContent(currentContent.type);
    }
  }, [currentContent, trackerEnabled, addReadContent, prevTs]);
}
function usePrevious(value) {
  let enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (enabled) ref.current = value;
  }, [value, enabled]);
  return ref.current;
}